import { Stack } from '@mui/material';
import { TrackerCriteriaFilter, TrackerCriteriaResults, TrackerCriteriaSummary } from '../components';

const TrackerRoute = () => {
    return (
        <>
            <Stack direction={'row'} gap={10}>
                <Stack direction={'column'} width={'20%'} style={{ alignItems: 'center' }}>
                    <TrackerCriteriaFilter />
                </Stack>
                <Stack direction={'column'} justifyContent={'flex-start'} style={{ width: '60%' }}>
                    <TrackerCriteriaResults />
                </Stack>
                <Stack direction={'column'} justifyContent={'flex-start'} style={{ width: '20%' }}>
                    <TrackerCriteriaSummary />
                </Stack>
            </Stack>
        </>
    );
};

export default TrackerRoute;
